<template>
    <WaterInfoWin v-show="false"
                   v-on:loaded-water-info="loadedWaterInfoHandle"
                   ref="waterInfoWin" />
</template>

<script>
import { $_TYPE, $_WC, $_ADM } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { mapGetters } from "vuex";
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";
import WaterInfoWin from "@/views/realtime/WaterInfoWin.vue";
export default {
    components: {
        WaterInfoWin,
    },
    data(){
        return {
            groupName: 'Water',
        };
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus: 'getSelectedSubMenus',
            subMenuList: 'getSubMenuList',
            waterQualityList: 'getWaterQualityList',
        }),
        subMenuInfo() {
            let subMap = gripUtil.toDict(this.subMenuList[this.selectedTopMenu], 'code');
            return subMap;
        },
    },
    watch: {
        selectedSubMenus: {
            immediate: false,
            handler(newVal, oldVal) {
                this.placeMarkers();
            }
        },
        waterQualityList: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.placeMarkers();
            }
        },
    },
    created() {
    },
    methods: {
        placeMarkers(){
            if(typeof this.geoJsonDrawing !== $_TYPE.UNDEF) {
                if(this.selectedTopMenu === 'Water') {
                    this.removeMarker(this.groupName);
                    this.geoJsonDrawing.setOptionAll("fillColor", "#96989B");
                    let selectedSubMenu = this.selectedSubMenus[0];
                    let unit = this.subMenuInfo[selectedSubMenu].subMenuMapUnit;
                    let waterQualityMap = gripUtil.toDict(this.waterQualityList, 'val4');

                    for(let addongCd in $_ADM.ADDONG_CENTER_MAP){
                        let dongNm = $_ADM.ADDONG_CENTER_MAP[addongCd].dongNm;
                        let lat = $_ADM.ADDONG_CENTER_MAP[addongCd].lat;
                        let lng = $_ADM.ADDONG_CENTER_MAP[addongCd].lng;

                        let val = '';
                        let qa = '';

                        let waterInfo = waterQualityMap[dongNm];

                        if(typeof waterInfo !== $_TYPE.UNDEF){
                            val = waterInfo[selectedSubMenu];
                            qa = airLevel.waterQuality(val, selectedSubMenu);
                        }
                        this.geoJsonDrawing.setFillColor(addongCd, qa[3]);
                        let htmlMarker = this.makeHtmlMarker(dongNm, val, unit, qa[0]);

                        let marker = new naver.maps.Marker({
                            position: new naver.maps.LatLng(lat, lng),
                            map: this.map,
                            title: dongNm,
                            icon: {
                                content: htmlMarker,
                                size: new naver.maps.Size(240, 240),
                                anchor: new naver.maps.Point(30, 30),
                            },
                        });

                        naver.maps.Event.addListener(marker, 'click', (event)=>{
                            this.$store.dispatch("SET_SELECTED_MARKER", marker);
                            this.$refs.waterInfoWin.setDongWaterInfo(waterInfo);
                        });

                        this.addMarkerMap(this.groupName, marker);
                        if(typeof waterInfo !== $_TYPE.UNDEF){
                            waterInfo.marker = marker;
                        }
                    }
                }
            }
        },
        loadedWaterInfoHandle(content){
            this.openInfoWin(content);
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
